<template>
  <div :style="containerStyle" class="pa-0 ma-0">
    <div :style="rowStyle">
      <!-- left column -->
      <div :style="leftStyle" class="pa-0 ma-0">
        <slot name="left" />
      </div>
      <!-- separator 1 -->
      <div ref="sep1" class="separator" @mousedown="startDrag($event, 1)" @touchstart="startDrag($event, 1)">
        <div style="display: flex; gap: 5px; justify-content: center; height: 28px;">
          <div style="background-color: #B1CCCF; width: 2px;"/>
          <div style="background-color: #B1CCCF; width: 2px;"/>
        </div>
      </div>
      <!-- middle column -->
      <div :style="middleStyle" class="pa-0 ma-0">
        <slot name="middle" />
      </div>
      <!-- separator 2 -->
      <div v-if="isThreeColumn" ref="sep2" class="separator" @mousedown="startDrag($event, 2)" @touchstart="startDrag($event, 2)">
        <div style="display: flex; gap: 5px; justify-content: center; height: 28px;">
          <div style="background-color: #B1CCCF; width: 2px;"/>
          <div style="background-color: #B1CCCF; width: 2px;"/>
        </div>
      </div>
      <!-- right column -->
      <div v-if="isThreeColumn" :style="rightStyle" class="pa-0 ma-0">
        <slot name="right" />
      </div>
    </div>
    <!-- right below if not three column -->
    <div v-if="!isThreeColumn" :style="rightStyle" class="pa-0 ma-0">
      <slot name="right" />
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseResizableTripleColumns",
  props: ["forceHorizontal"],
  data() {
    return {
      leftWidth: 50,
      middleWidth: 50,
      minWidth: 10
    };
  },
  computed: {
    isThreeColumn() {
      const dpr = window.devicePixelRatio || 1;
      const baseThreshold = this.$vuetify.display.thresholds.lg;
      const adjustedThreshold = baseThreshold * Math.max(1, dpr);
      return this.$vuetify.display.width >= adjustedThreshold;
    },
    containerStyle() {
      return {
        display: 'block',
        width: '100%'
      };
    },
    rowStyle() {
      return {
        display: 'flex',
        width: '100%'
      };
    },
    leftStyle() {
      return {
        width: `${this.leftWidth}% !important`,
        flex: '0 0 auto',
        minWidth: 0,
        overflow: 'hidden'
      };
    },
    middleStyle() {
      return {
        width: this.isThreeColumn ? `${this.middleWidth}% !important` : `${100 - this.leftWidth}% !important`,
        flex: '0 0 auto',
        minWidth: 0,
        overflow: 'hidden'
      };
    },
    rightStyle() {
      let style = {
        width: this.isThreeColumn ? `${100 - this.leftWidth - this.middleWidth}% !important` : '100% !important',
        flex: this.isThreeColumn ? '0 0 auto' : '',
        minWidth: 0,
        overflow: 'hidden'
      };
      if (!this.isThreeColumn) {
        style.marginTop = '6px !important';
      }
      return style;
    }
  },
  methods: {
    startDrag(e, sepNum) {
      e.stopPropagation();
      const startX = e.clientX || e.touches?.[0]?.clientX;
      const startLeft = this.leftWidth;
      const startMiddle = this.middleWidth;
      const containerWidth = this.$el.offsetWidth;

      const sepRef = sepNum === 1 ? 'sep1' : 'sep2';
      const separatorEl = this.$refs[sepRef];
      const computedStyle = getComputedStyle(separatorEl);
      const sepWidth = separatorEl.offsetWidth + parseFloat(computedStyle.marginLeft) + parseFloat(computedStyle.marginRight);
      const sepPercent = (sepWidth / containerWidth) * 100;

      const onMove = (moveE) => {
        moveE.preventDefault();
        moveE.stopPropagation();
        const clientX = moveE.clientX || moveE.touches?.[0]?.clientX;
        const deltaX = clientX - startX;
        const deltaPercent = (deltaX / containerWidth) * 100;

        if (sepNum === 1) {
          let newLeft = startLeft + deltaPercent;
          let adjust = this.isThreeColumn ? startMiddle : (100 - startLeft);
          let newAdjust = adjust - deltaPercent;

          newLeft = Math.max(this.minWidth, newLeft);
          newAdjust = Math.max(this.minWidth, newAdjust);
          newLeft = Math.min(100 - newAdjust - sepPercent, newLeft);

          this.leftWidth = newLeft;
          if (this.isThreeColumn) {
            this.middleWidth = newAdjust;
          }
        } else if (sepNum === 2) {
          let newMiddle = startMiddle + deltaPercent;
          newMiddle = Math.max(this.minWidth, newMiddle);
          newMiddle = Math.min(100 - startLeft - this.minWidth - sepPercent, newMiddle);
          this.middleWidth = newMiddle;
        }
      };

      const onEnd = () => {
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('touchmove', onMove);
        document.removeEventListener('mouseup', onEnd);
        document.removeEventListener('touchend', onEnd);
      };

      document.addEventListener('mousemove', onMove);
      document.addEventListener('touchmove', onMove, { passive: false });
      document.addEventListener('mouseup', onEnd);
      document.addEventListener('touchend', onEnd);
    }
  }
};
</script>

<style scoped>
.separator {
  flex: 0 0 10px;
  cursor: col-resize;
  display: flex;
  margin-inline: 16px;
  justify-content: center;
  align-items: flex-start;
  padding-top: 5px;
}
</style>